import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./IntroduccioIndividuFenofasesComentari.module.css";
import { Icon } from "antd";
import { introduccioMostrarComentari } from "../../actions";
import { getMostrarComentari } from "../../reducers";

class IntroduccioIndividuFenofasesComentari extends React.Component {
  mostrarComentariText = () => {
    const { introduccioMostrarComentari, observacioActual } = this.props;
    introduccioMostrarComentari(observacioActual.idIndividuFenofase);
  };

  // Render the child component and set the action property with the handler as value
  render() {
    const { observacioActual } = this.props;
    const crearComentari =
      observacioActual.idObservacion && observacioActual.valorActual ? (
        <div
          role="button"
          tabIndex="0"
          aria-label="Afegir comentari"
          className={
            styles.comentariIntroduccioSelectorImatgeContenidorImatgeAfegir
          }
          onClick={this.mostrarComentariText}
        >
          <Icon type="edit" style={{ fontSize: 20 }} />
        </div>
      ) : null;

    return <div className={styles.comentariIntroduccio}>{crearComentari}</div>;
  }
}

IntroduccioIndividuFenofasesComentari.propTypes = {
  props: PropTypes.object,
  observacioActual: PropTypes.object.isRequired,
  onDisableComponent: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    mostrarComentari: getMostrarComentari(state)
  };
};

export default connect(mapStateToProps, {
  introduccioMostrarComentari
})(IntroduccioIndividuFenofasesComentari);
